import { Input, Stack, Typography } from '@lyearn/ui';
import { FormComponentFieldTypeEnum, FormComponentType } from '@/types/schema';

import { getFieldType } from './utils';

interface MetaFieldProps {
  disabled?: boolean;
  error?: string;
  field: FormComponentType;
  value: string;
  onChange: (fieldName: string, value: string) => void;
  className?: string;
}
function MetaField({ error, field, value, onChange, className, disabled }: MetaFieldProps) {
  return (
    <Stack className={className} direction="col">
      <Typography className="ms-8" color="text-text-primary" variant="body-short-02">
        {field.label}
      </Typography>
      <Input
        disabled={disabled}
        error={Boolean(error)}
        multiline={field.type === FormComponentFieldTypeEnum.Multiline}
        name={field.name}
        placeholder={field.placeholder!}
        rows={6}
        size="large"
        type={getFieldType(field.type)}
        value={value}
        onChange={(event) => onChange(field.name, event.target.value)}
      />
      {error ? (
        <Typography className="ms-8" color="text-text-error" variant="body-short-03">
          {error}
        </Typography>
      ) : null}
    </Stack>
  );
}

export default MetaField;
